import styled from "styled-components";

export const NavBar = styled.div`
  height: 54px;
  display: block;
`;
